module.exports = __webpack_public_path__ + "static/media/Werewolf2.54356129.jpg";